import angular from 'angular'
import {
    rollticketSpec
} from 'redevConfig'


const list = (rollticketSpec && rollticketSpec.list) || ''

const rollticketSpecCtrl = list ? require(`redevelopment/system/rollticketSpec/${list.controllerName}`) : require('./rollticketSpecCtrl')

const rollticketSpecTemplate = list ? require(`redevelopment/system/rollticketSpec/${list.templateName}`) : require('./view/rollticketSpec.html')

export default angular
    .module('system.settingcenter.rollticketSpec', [])
    .config(['$stateProvider', function config($stateProvider) {
        $stateProvider
            .state('system.settingcenter.rollticketSpec', {
                abstract: true,
                url: '/rollticketSpec',
                template: '<div ui-view></div>',
                title: '卷票规格',
                default: 'system.settingcenter.rollticketSpec.list',
            })
            .state('system.settingcenter.rollticketSpec.list', {
                url: '/list',
                template: rollticketSpecTemplate,
                controller: 'rollticketSpecCtrl',
            })
    }])
    .controller('rollticketSpecCtrl', rollticketSpecCtrl.default)
    .name



// WEBPACK FOOTER //
// ./src/app/system/settingcenter/rollticketSpec/index.js